import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoService } from './info.service';
import { fromInfo } from '.';
import { StoreModule } from '@ngrx/store';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature(fromInfo.infoFeatureKey, fromInfo.reducer)],
  providers: [InfoService],
})
export class InfoStoreModule {}
